<template>
  <div class="logo">
        <span class="logo_title is-bold is-img"  @click="toindex()" style="cursor:pointer;">
          <transition name="fade">
            <template v-if="isCollapse" >
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-moren"></use>
						</svg>
            </template>
            <template v-else >
							<img v-if="userInfo.cusLogo!=''" :src="userInfo.cusLogo" style="width: 150px;max-height: 38px;" alt="">
             <img v-else src="@/assets/img/logo.png" style="width: 150px;max-height: 38px;" />
            </template>
          </transition>
        </span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import store from '@/store';
export default {
  name: 'logo',
  data() {
    return {
      logoPath: '',
      logoTextPath: '',
      userInfo: store.getters.userInfo,
    };
  },
  props: ['isCollapse'],
  created() {

  },
  computed: {
    ...mapGetters(['website', 'loginType','cusLogo']),
  },
  methods: {
    // 回到首页
    toindex() {
      this.$router.push({path: '/index'});
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-active {
  transition: opacity 2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.logo {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  /*width: 290px;*/
  height: 64px;
  line-height: 64px;
  /*background: #002140;*/
  color: #fdfdfd;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  overflow: hidden;
  box-sizing: border-box;
	margin-bottom: 30px;
}
.logo_title {
  padding:0;

  color: white;
  font-size: 30px;
  &.is-bold {
    font-weight: 700;
  }
}

.is-img {
  /*position: absolute;*/
  /*top: 10px;*/
  /*left: 13px;*/
  display:flex;
  align-items: center;
  justify-content: center;
}
.logo_subtitle {
  font-size: 16px;
  padding-top: 5px;
}

</style>
